export default "__VITE_ASSET__ToFqn5WQ__";